import { omit } from '../utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { getAccountDashboardUrl } from 'self-service-api/core/utilities/links';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const UIAccountSummaryButton = props => {
  const {
    trackingSource
  } = props;
  const propsToPass = omit(props, ['trackingSource', 'upgradeData', 'isUpgradePoint', 'level', 'canViewNewSeats']);
  const handleClick = () => {
    tracker.track('externalLinkClick', {
      name: 'account-summary',
      trackingSource
    });
  };
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    href: getAccountDashboardUrl(),
    onClick: handleClick,
    target: "_blank",
    truncate: true
  }, propsToPass, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.viewAccountButton.text"
    })
  }));
};
export default UIAccountSummaryButton;